<template>
	<AppDialog ref="dialog_container" dialogName="AddEmailDomainDialog" width="500px">
		<div class="add-email-domain-dialog">
			<span class="dialog-title flex-centerize">Add new domain</span>
			<div class="font-size-lg font-weight-500">Domain name</div>
			<AppTextField v-model="domainName" outlined hide-details placeholder="example.com" />
			<div class="font-size-lg font-weight-500">
				Return path name (optional)<br />The Return-Path is the address where bounces and other email feedback are sent. It is specified by
				the Return-Path header in an email.
			</div>
			<AppTextField v-model="returnPathName" outlined hide-details placeholder="pm.mtasv.net" />
			<div class="font-size-lg font-weight-500">Allowed emails (comma separated list of emails)</div>
			<AppTextField v-model="allowedEmails" outlined hide-details placeholder="team@example.com, john@example.com, jane@example.com" />
			<Row class="flex-justify-end mb-5">
				<PrimaryButton @click="addDomainClicked">Add domain</PrimaryButton>
			</Row>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { DataTypeEvaluator } from '@ply-io/data-types';
const evaluator = new DataTypeEvaluator();
const isEmail = evaluator.isEmail;

export default {
	name: 'AddEmailDomainDialog',
	components: { AppDialog },
	props: { dialogPromiseHandlers: { type: Object } },
	methods: {
		close() {
			AppDialogManagerService.closeCurrentDialog();
		},
		addDomainClicked() {
			const allowedEmails = this.allowedEmails.split(',').map((email) => email.trim());
			for (const email of allowedEmails) {
				if (!isEmail(email)) {
					this.$toast.error(`Invalid email address: '${email}'`);
					return;
				}
			}
			this.dialogPromiseHandlers.resolve({ domainName: this.domainName, returnPathName: this.returnPathName, allowedEmails });
			this.close();
		},
	},
	data() {
		return {
			domainName: '',
			returnPathName: '',
			allowedEmails: '',
		};
	},
};
</script>

<style scoped lang="scss">
.add-email-domain-dialog {
	border-radius: 15px !important;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16) !important;
	padding: 20px 30px 14px 30px;

	::v-deep(.widget-preview) {
		min-height: 350px !important;
	}
}
</style>
